import { render, staticRenderFns } from "./AddRawContact.vue?vue&type=template&id=a1818da4"
import script from "./AddRawContact.vue?vue&type=script&lang=js"
export * from "./AddRawContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports